'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (id, data) {
  return (0, _f3tch2.default)('/drivers/' + id + '/privacy_policy_accept/').profile('json').body((0, _stringify2.default)(data)).post();
};